export default {"src":"/_next/static/media/staysure-logo-primary.16e4fed3.svg","height":29,"width":115,"blurWidth":0,"blurHeight":0};